"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relativeHumidityConversions = relativeHumidityConversions;
const calculations_1 = require("@munters/calculations");
function relativeHumidityConversions(fromAmount, to, conversionParameters) {
    const pressureAmount = conversionParameters.pressure;
    const temperatureAmount = conversionParameters.temperature;
    switch (to) {
        case "HumidityRatio": {
            return calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToHumidityRatio(pressureAmount, temperatureAmount, fromAmount);
        }
        case "SpecificEnthalpy": {
            return calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToSpecificEnthalpy(pressureAmount, temperatureAmount, fromAmount);
        }
        case "DewPointTemperature": {
            return calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToDewPointTemperature(pressureAmount, temperatureAmount, fromAmount);
        }
        case "WetTemperature": {
            return calculations_1.Physics.RP1485.AmountConversions.relativeHumidityToWetTemperature(pressureAmount, temperatureAmount, fromAmount);
        }
        default: {
            throw new Error(`Can't convert ${fromAmount.unit.quantity} to ${to}`);
        }
    }
}
//# sourceMappingURL=relative-humidity-conversions.js.map